import { render, staticRenderFns } from "./dialogView.vue?vue&type=template&id=0c7fc360&scoped=true"
import script from "./dialogView.vue?vue&type=script&lang=js"
export * from "./dialogView.vue?vue&type=script&lang=js"
import style0 from "./dialogView.vue?vue&type=style&index=0&id=0c7fc360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7fc360",
  null
  
)

export default component.exports